import { render, staticRenderFns } from "./SubProjectView.vue?vue&type=template&id=668f5a76&scoped=true&"
import script from "./SubProjectView.vue?vue&type=script&lang=ts&"
export * from "./SubProjectView.vue?vue&type=script&lang=ts&"
import style0 from "./SubProjectView.vue?vue&type=style&index=0&id=668f5a76&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668f5a76",
  null
  
)

export default component.exports